import { useDispatch } from 'react-redux';

import { next } from '../../fsm/events';

const useConnect = () => {
  const dispatch = useDispatch();
  return {
    next: payload => dispatch(next(payload)),
  };
};

export default useConnect;
